import { combineReducers } from "redux";
import * as auth from "../app/modules/Auth/redux/authReducer";
import * as environnment from "../app/modules/GetEnvironment/getEnvironmentReducer";
import * as profile from "../app/modules/profile_settings/redux";
import snackBarReducer from "../app/modules/snackBar/snackbarReducer";
import * as contactUs from "../app/modules/contact_us/redux";
import * as coldLeads from "../app/modules/cold_leads/redux";
import * as newDataCall from "../app/modules/new_data_call/redux";
import * as incomingCalls from "../app/modules/incoming_calls/redux";
import * as quoteData from "../app/modules/quote/redux";
import * as genAIData from "../app/modules/generativeAI/redux";
import * as tag from "../app/modules/tag/redux";
import * as author from "../app/modules/AuthorManagement/redux";
import * as blog from "../app/modules/blog/redux";
import * as dubai_blog from "../app/modules/dubai_blog/redux";
import * as category from "../app/modules/Category/redux";
import * as emailManagement from "../app/modules/emailManagement/redux";
import * as mailSubscriber from "../app/modules/mailSubscriber/redux";
import * as whatsAppAccount from "../app/modules/whatsApp/accounts/redux";
import * as dashboard from "../app/modules/dashboards/redux";
import * as user from "../app/modules/users/redux";
import * as pageSpeedScore from "../app/modules/pageSpeedScore/redux";
import * as HfdiCareers from "../app/modules/Hfdi_careers/redux/";
import * as HfdiCareersInquiry from "../app/modules/Hfdi_Careers_Inquiry/redux";
import * as WebCareersCity from "../app/modules/webCareersCity/redux";
import * as Webcluescareers from "../app/modules/Webclues_careers/redux/";
import { hdpBlogReducer } from "../app/modules/Hdp_blog/redux";
import { hdpCategoryReducer } from "../app/modules/hdp_Category/redux";
import { hdpTagReducer } from "../app/modules/Hdp_tag/redux";
import { hdpAuthorReducer } from "../app/modules/hdp_author/redux";

export const rootReducer = combineReducers({
  snackBar: snackBarReducer,
  environnment: environnment.reducer,
  auth: auth.reducer,
  profile: profile.reducer,
  contactUs: contactUs.reducer,
  coldLeads: coldLeads.reducer,
  newDataCall: newDataCall.reducer,
  incomingCalls: incomingCalls.reducer,
  quoteData: quoteData.reducer,
  genAIData: genAIData.reducer,
  tag: tag.reducer,
  blog: blog.reducer,
  dubai_blog: dubai_blog.reducer,
  author: author.reducer,
  category: category.reducer,
  emailManagement: emailManagement.reducer,
  mailSubscriber: mailSubscriber.reducer,
  whatsAppAccount: whatsAppAccount.reducer,
  dashboard: dashboard.reducer,
  user: user.reducer,
  pageSpeedScore: pageSpeedScore.reducer,
  careers: HfdiCareers.reducer,
  careersInquiry: HfdiCareersInquiry.reducer,
  webcluescareers: Webcluescareers.reducer,
  webcluescareerscity: WebCareersCity.reducer,
  hdp_blog: hdpBlogReducer,
  hdp_category: hdpCategoryReducer,
  hdp_tag: hdpTagReducer,
  hdp_author: hdpAuthorReducer,
});
